import * as S from './PropertyTitle.styles';
import { PropertyTitleProps } from './PropertyTitle.types';

const PropertyTitle = (props: PropertyTitleProps) => <S.Container {...props} />;

export default PropertyTitle;
